import React from "react";
import Walkinchat from "../../components/walkin/walkinchat.index";
import Walkinlogo from "../../components/walkin/wakinlogo.index";
import Footerlogo from "../../components/walkin/footerlogo.index";
import "./walkin.style.css";
import { Layout } from "antd";
import Header from "../../components/Header";
// import Loader from "../../components/configure/Loader";
// import { useAuth } from "../../components/msalAuth/AuthProvider";

const { Content } = Layout;

const Walkin = () => {
  // const { login, isAuthenticated } = useAuth();

  // useEffect(() => {
  //   if (!isAuthenticated) {
  //     login();
  //   }
  // }, [isAuthenticated, login]);

  // if (!isAuthenticated) {
  //   return <Loader message="Redirecting to login..." />;
  // }

  return (
    <Layout className="wk-sandee-layout">
      <Header />
      <div className="wk-background-shapes">
        <div className="wk-shape wk-shape-1"></div>
        <div className="wk-shape wk-shape-2"></div>
        <div className="wk-shape wk-shape-3"></div>
      </div>

      <Content className="wk-sandee-content">
        <div className="wk-main-wrapper">
          <Walkinlogo />
          <Walkinchat />
        </div>
        <Footerlogo />
      </Content>
    </Layout>
  );
};

export default Walkin;
